import React from "react";
import { format, parseISO } from "date-fns";
import { sortingFns } from "@tanstack/react-table";
import { compareItems } from "@tanstack/match-sorter-utils";

import MasterTable from "../../../components/master/MasterTable";

import { contractAddIcon, downloadIcon } from "../../../assetData/icons";
import { actionPerm } from "../../../components/authNavigation/AuthNavbar";
import { downloadLoader } from "../../../assetData/loaders";

const fuzzySort = (rowA, rowB, columnId) => {
  let dir = 0;

  // Only sort by rank if the column has ranking information
  if (rowA.columnFiltersMeta[columnId]) {
    dir = compareItems(
      rowA.columnFiltersMeta[columnId]?.itemRank,
      rowB.columnFiltersMeta[columnId]?.itemRank,
    );
  }

  // Provide an alphanumeric fallback for when the item ranks are equal
  return dir === 0 ? sortingFns.alphanumeric(rowA, rowB, columnId) : dir;
};

const MasterPincodeTable = (props) => {
  const {
    tableData,
    buttonConfig,
    setIsAdd,
    setIsEdit,
    setIsDelete,
    setSelectedItemId,
    renderKey,
    loading,
    actionPermissions,
    setSelectedItem,
    isFilter,
    setIsFilter,
    isDownloadClicked,
  } = props;

  const columns = React.useMemo(
    () => [
      {
        accessorKey: "sl",
        header: () => <span>S. NO.</span>,
        cell: (info) => <span>{info.row.index + 1}.</span>,
      },

      {
        accessorFn: (row) => row.pincode,
        id: "pincode",
        cell: (info) => info.getValue(),
        header: () => <span>Pincode</span>,
        filterFn: "fuzzy",
        sortingFn: fuzzySort,
      },

      {
        accessorKey: "city",
        header: () => <span>CITY</span>,
        cell: (info) => <span> {info.getValue()} </span>,
      },

      {
        accessorKey: "state",
        header: () => <span>STATE</span>,
        cell: (info) => <span> {info.getValue()} </span>,
      },

      {
        accessorKey: "state_code",
        header: () => <span>ST. CODE</span>,
        cell: (info) => <span> {info.getValue()} </span>,
      },

      {
        accessorKey: "state_ut",
        header: () => <span>STATE-UT</span>,
        cell: (info) => <span> {info.getValue()} </span>,
      },

      {
        accessorKey: "status",
        header: () => <span>STATUS</span>,
        cell: (info) => (
          <span className="tracking-widest">
            {info.getValue() ? "ACTIVE" : "INACTIVE"}
          </span>
        ),
      },

      // {
      //   accessorKey: "eff_start_date",
      //   header: () => <span>START DATE</span>,
      //   cell: (info) =>
      //     info.getValue() && format(new Date(info.getValue()), "dd MMM yyyy"),
      // },

      {
        accessorKey: "updated_at",
        header: () => <span> UPDATED ON</span>,
        cell: (info) =>
          info.getValue() && format(parseISO(info.getValue()), "dd MMM yyyy"),
      },

      {
        accessorKey: "updated_by",
        header: () => <span> UPDATED BY</span>,
        cell: (info) => <span> {info.getValue()} </span>,
      },

      {
        accessorKey: "id",
        header: () => <span> ACTIONS</span>,
        cell: (info) => <span> </span>,
      },
    ],
    [],
  );

  const handleDownloadButtonClick = () => {
    buttonConfig.downloadHandler();
  };

  const actionConfig = [
    {
      id: "1",
      name: "Add Pincode",
      image: contractAddIcon,
      actionHandler: () => setIsAdd(true),
      disable: actionPerm(actionPermissions)?.add_perm,
    },

    {
      id: "2",
      name: "Download Data",
      image: isDownloadClicked ? downloadLoader : downloadIcon,
      actionHandler: isDownloadClicked
        ? () => {}
        : buttonConfig.downloadHandler,
      disable: actionPerm(actionPermissions)?.download_perm,
    },
  ];

  const action = actionPerm(actionPermissions);

  let name = "Add Pincode";

  return (
    <MasterTable
      name={name}
      columns={columns}
      tableData={tableData}
      buttonConfig={buttonConfig}
      setIsAdd={setIsAdd}
      setIsEdit={setIsEdit}
      setIsDelete={setIsDelete}
      setSelectedItemId={setSelectedItemId}
      renderKey={renderKey}
      actionConfig={actionConfig}
      loading={loading}
      handleDownloadButtonClick={handleDownloadButtonClick}
      actions={action}
      setSelectedItem={setSelectedItem}
      isFilter={isFilter}
      setIsFilter={setIsFilter}
    />
  );
};

export default MasterPincodeTable;
